// extracted by mini-css-extract-plugin
export default {"checkout-paddle-spin":"CheckoutPaddle_checkout-paddle-spin__6gNsZ"};